import * as store from './local-storage';

const decode = JSON.parse;
const encode = JSON.stringify;

function safely(func) {
  return function safe(...args) {
    try {
      return func(...args);
    } catch (e) {
      return e;
    }
  };
}

export default class StoredValue {
  constructor(key, fallback = undefined) {
    this.fallback = fallback;
    this.key = key;
  }

  get() {
    const str = store.getItem(this.key);
    if (str === null) return this.fallback;
    const value = safely(decode)(str);
    if (value instanceof Error) return this.fallback;
    return value;
  }

  set(value) {
    return store.setItem(this.key, encode(value));
  }

  clear() {
    return store.removeItem(this.key);
  }
}
